<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title step-name">Сведения о заявителе</div>

        <Subject
          :statement="statement"
          :subject="statement.subjects.applicant"
        />
      </v-col>
    </v-row>

    <v-row v-if="statement.extractionRodStep2">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Регистрационный номер распоряжения об отмене доверенности
        </div>
        <div>
          <Step2 :data="statement.extractionRodStep2" />
        </div>
      </v-col>
    </v-row>

    <v-row v-if="statement.extractionRodStep3">
      <v-col cols="12">
        <div class="form-base__title step-name">
          {{ Text.refusalDetailsTitle }}
        </div>

        <StepRequisites
          :data="statement.extractionRodStep3"
          :statement-type="StatementType.EXTRACTION_ROD"
        />
      </v-col>
    </v-row>

    <v-row v-if="statement.locationStep">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Выбор места совершения нотариального действия
        </div>

        <StepSign :data="statement.locationStep" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Subject from '@/components/elements/statement/FullStatementView/elements/Subject';
import Step2 from '@/components/elements/statement/FullStatementView/steps/ExtractionRod/Step2';
import StepRequisites from '@/components/elements/statement/FullStatementView/steps/common/StepRequisites';
import StepSign from '@/components/elements/statement/FullStatementView/steps/common/StepSign';
import { StatementType } from '@/types/services';
import { Text } from '@/utils/services';

export default {
  name: 'ExtractionRod',
  components: {
    Subject,
    Step2,
    StepRequisites,
    StepSign,
  },
  props: {
    statement: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    Text,
    StatementType,
  }),
};
</script>
